import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Tooltip, IconButton, TablePagination } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const RantingTable = ({ rantingUnits, onEdit, onDelete }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedRanting = rantingUnits.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Box sx={{ overflowX: 'auto' }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="ranting table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Nama Ranting</TableCell>
              <TableCell>Alamat</TableCell>
              <TableCell>Induk MWC</TableCell>
              <TableCell align="center">Pengguna Terkait</TableCell>
              <TableCell align="center">Aksi</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRanting.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  Belum ada data Ranting.
                </TableCell>
              </TableRow>
            ) : (
              paginatedRanting.map((ranting) => (
                <TableRow key={ranting.id}>
                  <TableCell>{ranting.id}</TableCell>
                  <TableCell>{ranting.name}</TableCell>
                  <TableCell>{ranting.address || '-'}</TableCell>
                  <TableCell>{ranting.mwc?.name || 'N/A'}</TableCell>
                  <TableCell align="center">{ranting._count?.users || 0}</TableCell>
                  <TableCell align="center">
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Tooltip title="Edit Ranting">
                        <IconButton onClick={() => onEdit(ranting)} color="primary">
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Hapus Ranting">
                        <IconButton onClick={() => onDelete(ranting.id)} color="error">
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rantingUnits.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </Box>
  );
};

export default RantingTable;
